import { gql } from '@common/hooks';
import { OrganizationBusinessType } from '@institutions/types';

export const createOrganizationBusinessMutation = gql`
  mutation CreateOrganizationBusinessMutation(
    $input: CreateOrganizationBusinessInput!
  ) {
    createOrganizationBusiness(input: $input) {
      organizationBusiness {
        id
        name
        address
        postalCode
        city
        country
        stateCode
        timeZone
      }
    }
  }
`;

export type CreateOrganizationBusinessMutationVariables = {
  input: {
    name: string;
    address: string;
    postalCode: string;
    city: string;
    country: string;
    stateCode: string;
    timeZone: string;
  };
};

export type CreateOrganizationBusinessMutationResponse = {
  createOrganizationBusiness: {
    organizationBusiness: OrganizationBusinessType;
  };
};
